import React, {useRef, useState} from 'react';
import styles from './styles';
import {Button, Icons} from '@xpertdox_js/xdcomponents';
import {colors} from '@xpertdox_js/xdstyle';
import EditQuestion from './editQuestion';
import { trackActivity } from '../../utils/activityTracker'
import { UserContext } from '../../Context/UserContext'
import { InstanceContext } from '../../InstanceContext'

const SurveyQuestions = props => {
	const [editQuestion, setEditQuestion] = useState(() => false)
	const [editIndex, setEditIndex] = useState(() => null)
  const hydrateQuestion = useRef(false)
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)

	const defaultQuestion = {
		label: '',
		avail: true,
		type: null,
		options: null
	}

	const [newQuestion, setNewQuestion] = useState(() => defaultQuestion)

	const [warning, setWarning] = useState(false)

	let defaultQuestions = props.type !== 'surveyQuestions' ? [] : !props.overviewForm.current.surveyQuestions ? [
		{
			label: `Are you a current ${props.instanceSettings.facility} patient?`,
			avail: props.instanceSettings.survey.question1,
			type: 'checkBox',
			options: [
				{label: 'Yes', value: 'Yes'},
				{label: 'No', value: 'No'}
			]
		},
		{
			label: `How did you learn about ${props.instanceSettings.facility} Trial Search Platform?`,
			avail: props.instanceSettings.survey.question2,
			type: 'checkBox',
			options: [
				{ value: 'print_media', label: 'Print Media' },
				{ value: 'google', label: 'Search Engine (Google)' },
				{ value: 'physician', label: 'Your Physician' },
				{ value: 'word_of_mouth', label: 'Word of  Mouth' },
				{ value: 'facebook', label: 'Social Media (Facebook)' }
			]
		}
	] : props.overviewForm.current.surveyQuestions;

	const [questions, setQuestions] = useState(() => ([...defaultQuestions]))

	if(props.overviewForm.prescreenQuestions && props.overviewForm.prescreenQuestions.length !== 0 && !hydrateQuestion.current) {
		setQuestions(props.overviewForm.prescreenQuestions)
		hydrateQuestion.current = true
	}

	if(props.type === 'surveyQuestions' && props.overviewForm.current.surveyQuestions && props.overviewForm.current.surveyQuestions.length !== 0 && !hydrateQuestion.current) {
		setQuestions(props.overviewForm.current.surveyQuestions)
		hydrateQuestion.current = true
	}


  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

	const handleEditClick = (e, question, index) => {
		console.log(e, question)
		if(question) {
			setNewQuestion(question)
			setEditIndex(index)
		}

		if(!e) {
			setNewQuestion(defaultQuestion)
			setEditQuestion(false)
		} else {
			if(questions.length >= 5){
				setWarning('Can only add up to 5 questions')
				setTimeout(() => setWarning(false), 6000)
			} else setEditQuestion(true)

    }
    handleActivityLogUpdate(`SurveyQuestions.handleEditClick.(${question ? question : null})`)
	}

	const removeQuestion = (e, questionIndex) => {
		let questionsSet = [...questions];
		questionsSet.splice(questionIndex, 1);
		setQuestions(questionsSet);
		if(props.type === 'surveyQuestions') props.overviewForm.current.surveyQuestions = questionsSet;
    else props.updateQuestions(questionsSet);
    handleActivityLogUpdate(`SurveyQuestions.removeQuestion`)
	}

	const addQuestion = (e) => {
		let newSetQuestions = [...questions];

		if(editIndex !== null) newSetQuestions[editIndex] = newQuestion;
		else  newSetQuestions.push(newQuestion)

		setQuestions(newSetQuestions)
		if(props.type === 'surveyQuestions') props.overviewForm.current.surveyQuestions = newSetQuestions;
		else props.updateQuestions(newSetQuestions);
		handleEditClick(false)
    setEditIndex(null)
    handleActivityLogUpdate(`SurveyQuestions.addQuestion`)
	}

	const singleQuestion = (question, index) => {
		return <li key={index} style={styles.list.listItem}>
			<span>
				{question.label}
				{
					props.edit &&
					<span style={{color: colors.xdHighlight,cursor: 'pointer', marginLeft: 3}}>
						<Icons icon='edit' onClick={e => handleEditClick(e, question, index)} style={{marginLeft: 2.5, height: 16, width: 16, fill: colors.xdHighlight}} />
						<Icons icon='trash' onClick={e => removeQuestion(e, index)} style={{marginLeft: 2.5, height: 18, width: 18, fill: colors.error}} />
					</span>
				}
			</span>
			{question.options && <div style={{paddingLeft: 8}}>
				<p>Options: {question.options.map((o, i) => <span style={{fontWeight: 400}} key={i}>
					{o.label}
					{props.type === 'surveyQuestions' ? null : o.optionType && o.optionType === 'out' ? ' (Ineligible)' : ' (Eligible)'}
					{i !== question.options.length -1 && ', '}
				</span>)}</p>
			</div>}
		</li>
	}

	return <div>
    <p style={{fontSize: '1.4rem', marginTop: 3, maxWidth: '60%'}}>
      {
        props.type.surveyQuestions
        ? 'Survey questions are asked at the time of submission for a trial on the patient-facing interface (XpertTrial).'
        : 'These questions will be displayed on the trial overview page in the XpertTrial interface and for XpertScreen, they will come up once a user selects the trial for referral.'
      }
    </p>
    <div style={{
      position:'absolute',
      top: 8,
      right: 10
    }}>
      {props.edit && <Button
        onClick={e => handleEditClick(!editQuestion,null)}
        styles={{
          ...styles.button.container,
          marginRight: 8,
          backgroundColor: editQuestion ? colors.error : colors.xdDarkBlue
        }}
        hoverStyles={styles.button.buttonHov}
        focusStyles={styles.button.buttonFoc}
        title={editQuestion ? 'Cancel' : 'Add Question'}>
        <span>{editQuestion ? 'Cancel' : 'Add Question'}</span>
      </Button>}
      {props.type === 'surveyQuestions' && <Button
        onClick={e => !props.edit ? props.toggleEdit(e) : props.saveSurvey(e)}
        styles={{
          ...styles.button.container,
          backgroundColor: !props.edit ? colors.xdDarkBlue : colors.success
        }}
        hoverStyles={styles.button.buttonHov}
        focusStyles={styles.button.buttonFoc}
        title={!props.edit ? 'Edit Questions' : 'Save Changes'}
      >
        <span>{!props.edit ? 'Edit Questions' : 'Save Changes'}</span>
      </Button>}
    </div>
		{warning && <p style={styles.warning}>{warning}</p>}
		<div>
			{editQuestion && props.edit ? <EditQuestion
				newQuestion={{
					value: newQuestion,
					set: setNewQuestion
				}}
				addQuestion={addQuestion}
				type={props.type}
			/> : ''}
		</div>
		<ul style={{
		  ...styles.list.container,
      paddingTop: 10,
      borderTop: `1px solid ${colors.lightGray}`,
		  textAlign: 'center'
		}}>
			{questions.length === 0 && 'No questions added'}
			{questions.map((q, index) => singleQuestion(q, index))}
		</ul>

	</div>
}

export default SurveyQuestions;
